<script setup>
/**
 * FormControlModulestructureTableTargetColumn
 * Composition-based wrapper around the standard select dropdown form control.
 * Parses cross-component relationship schemas to formulate unified relational option links,
 * automatically dropping its visual layout visibility if the current property type is not 'table'.
 */
import {computed, onMounted} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useComponentStructureStore} from '@/stores/componentStructure'
import FormControlTypeSelect from '@/common/form-control-type/FormControlTypeSelect.vue'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const componentsStore = useComponentsStore()
const componentStructureStore = useComponentStructureStore()

const options = computed(() => {
    const structureItems = componentStructureStore.items || []
    const componentItems = componentsStore.items || []
    const targetModuleId = props.currentData?.modulecomponentsID || props.currentData?.modulecomponentsId

    const filteredStructures = structureItems.filter((obj) => {
        return obj.categoryComponentId === targetModuleId && obj.type === 'relationshipOneToMany'
    })

    const selectOptions = []

    filteredStructures.forEach((item) => {
        const component = componentItems
            .find(obj => obj.id === item.modulecomponentsID || obj.id === item.modulecomponentsId)

        if (component) {
            selectOptions.push({
                value: item.id,
                text: `${component.title} > ${item.title}`
            })
        }
    })

    return selectOptions
})

onMounted(() => {
    if (props.currentData?.type !== 'table' && props.field) {
        props.field.hidden = true
    }
})
</script>

<template>
    <FormControlTypeSelect
        v-if="options && options.length"
        :current-data="currentData"
        :field="field"
        :form-id="formId"
        :options="options"
    />
</template>